const getCanonicalUrl = (url = '') => {
  if (!url) {
    return '';
  }

  try {
    const canonicalUrl = new URL(url);
    canonicalUrl.protocol = 'https:'; // see: https://github.com/remix-run/remix/issues/420

    let pathname = canonicalUrl.pathname.toLowerCase();
    if (pathname.length > 1 && pathname.endsWith('/')) {
      pathname = pathname.slice(0, -1);
    }

    return canonicalUrl.origin + pathname;
  } catch (_e) {
    return '';
  }
};

export default getCanonicalUrl;
